import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminManageUsersService } from 'src/app/services/admin-manage-users/admin-manage-users.service';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import { OBPPLoginService } from 'src/app/services/login-page/login-page.service';

@Component({
  selector: 'app-modal-reject-user',
  templateUrl: './modal-reject-user.component.html',
  styleUrls: ['./modal-reject-user.component.scss']
})
export class ModalRejectUserComponent implements OnInit {
  @Input() user_data: any;
  @Input() modalType: string = '';
  @Input() collectReasonOnly: boolean = false;
  @Input() maxReasonLength: number = 250;
  @Output() successAction = new EventEmitter();
  @Output() cancelAction = new EventEmitter();
  @ViewChild('rejectJustification')
  rejectJustification!: ElementRef
  displayErrorMsgBlock: boolean = false;
  currentLength: number = 0;
  constructor(
    public activeModal: NgbActiveModal,
    private dataSharingService: DataSharingService,
    private manageUsersService: AdminManageUsersService,
    private obbpLoginService: OBPPLoginService
  ) { }

  ngOnInit(): void {
  }

  confirmUserRejection() {
    const rejectJustification = this.rejectJustification.nativeElement.value.trim();
    this.currentLength = rejectJustification.length;

    if (!rejectJustification) {
      this.displayErrorMsgBlock = true;
      return;
    }

    if (this.collectReasonOnly) {
      this.displayErrorMsgBlock = false;
      this.successAction.emit(rejectJustification);
      this.activeModal.close('Success');
      return;
    } else {
      this.displayErrorMsgBlock = false;
      this.dataSharingService.IsLoadingEnabled.next(true);
      this.user_data.rejectJustification = rejectJustification;
      this.manageUsersService.rejectUserProfile(this.user_data, this.obbpLoginService.getAuthToken()).subscribe((data) => {
        this.dataSharingService.IsLoadingEnabled.next(false);
        this.successAction.emit(rejectJustification);
        this.activeModal.close('Success');

      }, error => {
        console.error(error);
        this.dataSharingService.IsLoadingEnabled.next(false);
        this.activeModal.close('Success');
      })
    }
  }
  cancelUserRejection() {
    this.cancelAction.emit();
    this.activeModal.close('Cancel');
  }

}
